import { Button, Card, CardContent, CardDescription, CardHeader, CardTitle } from '@data-delivery/d3s';
import { useNavigate } from 'react-router-dom';

export function NotFoundPage() {
  const navigate = useNavigate();
  return (
    <div className='container flex h-screen w-screen flex-col items-center justify-center'>
      <Card className='w-[350px]'>
        <CardHeader>
          <CardTitle>Nothing is here!</CardTitle>
          <CardDescription>You are looking at wrong place.</CardDescription>
        </CardHeader>
        <CardContent>
          <div className='grid gap-1'>
            <Button
              type='button'
              onClick={() => {
                navigate('/');
              }}
            >
              Go Back to home page
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
